$(function() {
    const swiperSocial = new Swiper('#swiper-social', {
        slidesPerView: 1.3,
        spaceBetween: 0,
        touchStartPreventDefault: false,
        breakpoints: {
            768: {
                slidesPerView: 2.5,
            },
            993: {
                slidesPerView: 3.3,
            }
        },
        autoplay: {
            delay: 2000,
            disableOnInteraction: true,
        },
    });

     // Function to start or stop autoplay based on visibility
     const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                swiperSocial.autoplay.start(); // Start autoplay when visible
            } else {
                swiperSocial.autoplay.stop(); // Stop autoplay when not visible
            }
        });
    });

    // Observe the Swiper container
    const swiperContainer = document.querySelector('#swiper-social');
    observer.observe(swiperContainer);
   
});

